(ns hai.tasks.urgency
  "The task urgency vocabulary: the three `:task.urgency/*` idents and their
   display labels, shared by every surface that sets or groups tasks by
   urgency.")

(def options
  "Ordered urgency choices, most-to-least urgent."
  [{:value :task.urgency/now   :label "Now"}
   {:value :task.urgency/next  :label "Next"}
   {:value :task.urgency/later :label "Later"}])

(def default
  "Where a task with no urgency of its own starts. Later is the untriaged lane,
   so a task nobody triages is born there — and it is what the composer opens at
   until the user picks another default."
  :task.urgency/later)

(defn label
  "Display label for one `:task.urgency/*` ident."
  [urgency]
  (some (fn [option]
          (when (= urgency (:value option))
            (:label option)))
        options))
